import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["childKey", "className", "data", "defaultChecked", "defaultExpanded", "defaultExpandAll", "disabledValues", "emptyState", "height", "id", "isCascade", "isDisabled", "isLoading", "loadingText", "labelKey", "metadataKey", "mode", "onChange", "onExpand", "onlyLeafCheckboxes", "onlyLeafChecked", "onlyParentChecked", "onSelect", "resize", "size", "uncheckableValues", "valueKey", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { forwardRef, useCallback, useEffect, useState, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Tree.styles';
import Checkbox from '../Checkbox';
import Loading from '../Loading';
import Icon from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Tree = forwardRef(function (_ref, ref) {
  var _cx;

  var _ref$childKey = _ref.childKey,
      childKey = _ref$childKey === void 0 ? 'children' : _ref$childKey,
      customClassName = _ref.className,
      dataFromProp = _ref.data,
      defaultChecked = _ref.defaultChecked,
      defaultExpanded = _ref.defaultExpanded,
      _ref$defaultExpandAll = _ref.defaultExpandAll,
      defaultExpandAll = _ref$defaultExpandAll === void 0 ? false : _ref$defaultExpandAll,
      disabledValues = _ref.disabledValues,
      emptyState = _ref.emptyState,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 280 : _ref$height,
      id = _ref.id,
      _ref$isCascade = _ref.isCascade,
      isCascade = _ref$isCascade === void 0 ? true : _ref$isCascade,
      _ref$isDisabled = _ref.isDisabled,
      treeIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$loadingText = _ref.loadingText,
      loadingText = _ref$loadingText === void 0 ? 'Please wait while we are fetching the content' : _ref$loadingText,
      _ref$labelKey = _ref.labelKey,
      labelKey = _ref$labelKey === void 0 ? 'label' : _ref$labelKey,
      _ref$metadataKey = _ref.metadataKey,
      metadataKey = _ref$metadataKey === void 0 ? 'metadata' : _ref$metadataKey,
      mode = _ref.mode,
      onChange = _ref.onChange,
      onExpand = _ref.onExpand,
      _ref$onlyLeafCheckbox = _ref.onlyLeafCheckboxes,
      onlyLeafCheckboxes = _ref$onlyLeafCheckbox === void 0 ? false : _ref$onlyLeafCheckbox,
      _ref$onlyLeafChecked = _ref.onlyLeafChecked,
      onlyLeafChecked = _ref$onlyLeafChecked === void 0 ? false : _ref$onlyLeafChecked,
      _ref$onlyParentChecke = _ref.onlyParentChecked,
      onlyParentChecked = _ref$onlyParentChecke === void 0 ? false : _ref$onlyParentChecke,
      onSelect = _ref.onSelect,
      _ref$resize = _ref.resize,
      resize = _ref$resize === void 0 ? 'both' : _ref$resize,
      size = _ref.size,
      uncheckableValues = _ref.uncheckableValues,
      _ref$valueKey = _ref.valueKey,
      valueKey = _ref$valueKey === void 0 ? 'value' : _ref$valueKey,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 428 : _ref$width,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-tree"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var data = useMemo(function () {
    if (dataFromProp && (dataFromProp === null || dataFromProp === void 0 ? void 0 : dataFromProp.length) === 1) {
      dataFromProp[0].rootNode = true;
    }

    return Array.isArray(dataFromProp) ? dataFromProp : [];
  }, [dataFromProp]);
  var getHasData = useCallback(function () {
    return (data === null || data === void 0 ? void 0 : data.length) >= 1;
  }, [data]);

  var _useState = useState(getHasData()),
      _useState2 = _slicedToArray(_useState, 2),
      hasData = _useState2[0],
      setHasData = _useState2[1];

  useEffect(function () {
    setHasData(getHasData());
  }, [getHasData]);
  var getParentNodes = useCallback(function () {
    var parentNodes = [];

    var iterate = function iterate(arr) {
      var _iterator = _createForOfIteratorHelper(arr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;

          if (getIsParent(node)) {
            parentNodes.push(node);
            iterate(node[childKey]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    hasData && iterate(data);
    return parentNodes;
  }, [childKey, data, hasData]);

  var _useState3 = useState(getParentNodes()),
      _useState4 = _slicedToArray(_useState3, 2),
      parentNodes = _useState4[0],
      setParentNodes = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      parentValues = _useState6[0],
      setParentValues = _useState6[1];

  useEffect(function () {
    var _parentNodes = getParentNodes();

    setParentNodes(_parentNodes);
    setParentValues(function () {
      var parentValues = [];

      var _iterator2 = _createForOfIteratorHelper(_parentNodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          parentValues.push(node[valueKey]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return parentValues;
    });
  }, [getParentNodes, valueKey]);
  var getUncheckable = useCallback(function () {
    return (uncheckableValues === null || uncheckableValues === void 0 ? void 0 : uncheckableValues.length) > 0 ? uncheckableValues : [];
  }, [uncheckableValues]);

  var _useState7 = useState(getUncheckable()),
      _useState8 = _slicedToArray(_useState7, 2),
      uncheckable = _useState8[0],
      setUncheckable = _useState8[1];

  useEffect(function () {
    setUncheckable(getUncheckable());
  }, [getUncheckable]);
  var getDisabled = useCallback(function () {
    function disableChildren() {
      var _disabledValues = [];

      var iterate = function iterate(arr) {
        var _iterator3 = _createForOfIteratorHelper(arr),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var node = _step3.value;
            var isDisabled = disabledValues.includes(node[valueKey]);
            var isParent = getIsParent(node);

            if (isDisabled) {
              _disabledValues.push(node[valueKey]);

              if (isParent) {
                var children = getDeepChildren(node);

                var _iterator4 = _createForOfIteratorHelper(children),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var child = _step4.value;

                    _disabledValues.push(child[valueKey]);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
            }

            if (isParent) {
              iterate(node[childKey]);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      };

      iterate(data);
      return _disabledValues;
    }

    if (hasData && (disabledValues === null || disabledValues === void 0 ? void 0 : disabledValues.length) > 0) {
      return isCascade ? disableChildren() : disabledValues;
    } else {
      return [];
    }
  }, [childKey, data, disabledValues, hasData, isCascade, valueKey]);

  var _useState9 = useState(getDisabled()),
      _useState10 = _slicedToArray(_useState9, 2),
      disabled = _useState10[0],
      setDisabled = _useState10[1];

  useEffect(function () {
    setDisabled(getDisabled());
  }, [getDisabled]);
  var getChecked = useCallback(function () {
    function checkChildren() {
      var _defaultChecked = new Set(defaultChecked);

      var iterate = function iterate(arr) {
        var _iterator5 = _createForOfIteratorHelper(arr),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var node = _step5.value;

            if (getIsParent(node)) {
              var isDefaultChecked = defaultChecked.includes(node[valueKey]);

              if (isDefaultChecked) {
                var deepChildren = getDeepChildren(node);

                var _iterator6 = _createForOfIteratorHelper(deepChildren),
                    _step6;

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var child = _step6.value;

                    if (!uncheckable.includes(child[valueKey])) {
                      _defaultChecked.add(child[valueKey]);
                    }
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              }

              iterate(node[childKey]);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      };

      iterate(data);
      return Array.from(_defaultChecked);
    }

    if (hasData && (defaultChecked === null || defaultChecked === void 0 ? void 0 : defaultChecked.length) > 0) {
      return isCascade ? checkChildren() : defaultChecked;
    } else {
      return [];
    }
  }, [childKey, data, defaultChecked, hasData, isCascade, valueKey]);

  var _useState11 = useState(getChecked()),
      _useState12 = _slicedToArray(_useState11, 2),
      checked = _useState12[0],
      setChecked = _useState12[1];

  useEffect(function () {
    setChecked(getChecked());
  }, [getChecked]);
  var getExpanded = useCallback(function () {
    function expandParents() {
      var _defaultExpanded = new Set(defaultExpanded);

      var iterate = function iterate(arr) {
        var _iterator7 = _createForOfIteratorHelper(arr),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var node = _step7.value;

            if (getIsParent(node)) {
              var deepChildren = getDeepChildren(node);

              var _iterator8 = _createForOfIteratorHelper(deepChildren),
                  _step8;

              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var child = _step8.value;

                  if (defaultExpanded.includes(child[valueKey])) {
                    _defaultExpanded.add(node[valueKey]);
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }

              iterate(node[childKey]);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      };

      iterate(data);
      return Array.from(_defaultExpanded);
    }

    if (hasData && defaultExpandAll) {
      return parentValues;
    } else if (hasData && !defaultExpandAll && defaultExpanded !== null && defaultExpanded !== void 0 && defaultExpanded.length) {
      return expandParents();
    } else {
      return [];
    }
  }, [childKey, data, defaultExpandAll, defaultExpanded, hasData, parentNodes, parentValues, valueKey]);

  var _useState13 = useState(getExpanded()),
      _useState14 = _slicedToArray(_useState13, 2),
      expanded = _useState14[0],
      setExpanded = _useState14[1];

  useEffect(function () {
    setExpanded(getExpanded());
  }, [getExpanded]);

  function getDeepChildren(node) {
    var isParent = getIsParent(node);
    var deepChildren = [];

    function iterate(node) {
      var children = node[childKey];

      var _iterator9 = _createForOfIteratorHelper(children),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _node = _step9.value;
          deepChildren.push(_node);

          if (getIsParent(_node)) {
            iterate(_node);
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return deepChildren;
    }

    return isParent ? iterate(node) : [];
  }

  function getIsExpanded(node) {
    var _expanded$includes;

    return (_expanded$includes = expanded === null || expanded === void 0 ? void 0 : expanded.includes(node[valueKey])) !== null && _expanded$includes !== void 0 ? _expanded$includes : false;
  }

  function getIsParent(node) {
    return node[childKey] && node[childKey].length >= 1;
  }

  function isEveryChildChecked(children) {
    return children.every(function (child) {
      return getIsChecked(child);
    });
  }

  function isSomeChildChecked(children) {
    return children.some(function (child) {
      return getIsChecked(child);
    });
  }

  function getIsUncheckable(node) {
    var _uncheckable$includes;

    return (_uncheckable$includes = uncheckable === null || uncheckable === void 0 ? void 0 : uncheckable.includes(node[valueKey])) !== null && _uncheckable$includes !== void 0 ? _uncheckable$includes : false;
  }

  function getIsDisabled(node) {
    var _disabled$includes;

    return (_disabled$includes = disabled === null || disabled === void 0 ? void 0 : disabled.includes(node[valueKey])) !== null && _disabled$includes !== void 0 ? _disabled$includes : false;
  }

  function getIsChecked(node) {
    if (isCascade) {
      return checked.includes(node[valueKey]) || getIsParent(node) && isEveryChildChecked(node[childKey]);
    } else {
      return checked.includes(node[valueKey]);
    }
  }

  function getIsIndeterminate(node) {
    if (isCascade && getIsParent(node)) {
      var children = getDeepChildren(node);

      if (isEveryChildChecked(children)) {
        return false;
      } else {
        return isSomeChildChecked(children);
      }
    } else {
      return false;
    }
  }

  function cascadeCheck(_checked, node) {
    _checked.add(node[valueKey]);

    if (getIsParent(node)) {
      var deepChildren = getDeepChildren(node);

      var _iterator10 = _createForOfIteratorHelper(deepChildren),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _node2 = _step10.value;

          if (!getIsDisabled(_node2) && !getIsUncheckable(_node2)) {
            _checked.add(_node2[valueKey]);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return toggleParents(_checked);
  }

  function cascadeUnCheck(_checked, node) {
    _checked["delete"](node[valueKey]);

    if (getIsParent(node)) {
      var deepChildren = getDeepChildren(node);

      var _iterator11 = _createForOfIteratorHelper(deepChildren),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _node3 = _step11.value;

          if (!getIsDisabled(_node3) && !getIsUncheckable(_node3)) {
            _checked["delete"](_node3[valueKey]);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }

    return toggleParents(_checked);
  }

  function handleIndeterminate(_checked, node) {
    var deepChildren = getDeepChildren(node);
    var shallowChildren = deepChildren.filter(function (node) {
      return !getIsDisabled(node) && !getIsUncheckable(node) && !getIsParent(node);
    });
    var everyChildChecked = shallowChildren.every(function (node) {
      return _checked.has(node[valueKey]);
    });

    if (everyChildChecked) {
      var _iterator12 = _createForOfIteratorHelper(deepChildren),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var child = _step12.value;

          if (!getIsDisabled(child) && !getIsUncheckable(child)) {
            _checked["delete"](child[valueKey]);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    } else {
      var _iterator13 = _createForOfIteratorHelper(deepChildren),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _child = _step13.value;

          if (!getIsDisabled(_child) && !getIsUncheckable(_child)) {
            _checked.add(_child[valueKey]);
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }

    return toggleParents(_checked);
  }

  function toggleParents(_checked) {
    var checkableParents = parentNodes.filter(function (node) {
      return !getIsDisabled(node) && !getIsUncheckable(node);
    });

    var _iterator14 = _createForOfIteratorHelper(checkableParents),
        _step14;

    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var node = _step14.value;
        var deepChildren = getDeepChildren(node);
        var shallowChildren = deepChildren.filter(function (node) {
          return !getIsParent(node);
        });
        var everyChildChecked = shallowChildren.every(function (child) {
          return _checked.has(child[valueKey]);
        });

        if (everyChildChecked) {
          _checked.add(node[valueKey]);
        } else {
          _checked["delete"](node[valueKey]);
        }
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }

    return _checked;
  }

  function handleOnChange(node, isChecked, isIndeterminate) {
    var _checked = new Set(checked);

    if (isCascade) {
      if (!isChecked && !isIndeterminate) {
        _checked = cascadeCheck(_checked, node);
      }

      if (isChecked) {
        _checked = cascadeUnCheck(_checked, node);
      }

      if (isIndeterminate) {
        _checked = handleIndeterminate(_checked, node);
      }
    }

    if (!isCascade) {
      if (isChecked) {
        _checked["delete"](node[valueKey]);
      } else {
        _checked.add(node[valueKey]);
      }
    }

    var onChangeData = function onChangeData() {
      var checkedData = Array.from(_checked).filter(function (value) {
        return !uncheckable.includes(value);
      });

      if (onlyLeafChecked) {
        var onlyLeafData = checkedData.filter(function (value) {
          return !parentValues.includes(value);
        });
        return onlyLeafData;
      } else if (onlyParentChecked) {
        var _ret = function () {
          var onlyParentData = new Set(checkedData);

          var _iterator15 = _createForOfIteratorHelper(parentNodes),
              _step15;

          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _node4 = _step15.value;
              var nodeChildren = _node4[childKey];
              var everyChildIsChecked = nodeChildren.every(function (child) {
                return onlyParentData.has(child[valueKey]);
              });
              var parentIsCheckable = !uncheckable.includes(_node4[valueKey]);

              if (everyChildIsChecked && parentIsCheckable) {
                var _iterator16 = _createForOfIteratorHelper(nodeChildren),
                    _step16;

                try {
                  for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                    var _node5 = _step16.value;
                    onlyParentData["delete"](_node5[valueKey]);
                  }
                } catch (err) {
                  _iterator16.e(err);
                } finally {
                  _iterator16.f();
                }
              }
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }

          return {
            v: Array.from(onlyParentData)
          };
        }();

        if (_typeof(_ret) === "object") return _ret.v;
      } else {
        return checkedData;
      }
    };

    onChange && onChange(onChangeData(), node);
    onSelect && onSelect({
      checked: _checked.has(node[valueKey]),
      expanded: expanded.includes(node[valueKey]),
      parent: parentValues.includes(node[valueKey])
    }, node);
    setChecked(Array.from(_checked));
  }

  function handleOnExpand(node, isOpen) {
    var _expanded = new Set(expanded);

    if (isOpen) {
      _expanded["delete"](node[valueKey]);
    } else {
      _expanded.add(node[valueKey]);
    }

    setExpanded(Array.from(_expanded));
    onExpand && onExpand(Array.from(_expanded), node);
  }

  function createTree(data, marginLeft) {
    return data.map(function (node, index) {
      var _cx2;

      var isRootNode = node.rootNode === true;
      var isParent = getIsParent(node);
      var isChecked = getIsChecked(node);
      var isDisabled = treeIsDisabled || getIsDisabled(node);
      var isExpanded = getIsExpanded(node);
      var isIndeterminate = getIsIndeterminate(node);
      var isUncheckable = getIsUncheckable(node);
      return _jsxs(Styled.TreeLeaf, {
        style: {
          marginLeft: marginLeft
        },
        children: [_jsxs(Styled.Node, {
          className: cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-tree__node--isDisabled"), isDisabled || isUncheckable), _defineProperty(_cx2, "".concat(prefix, "-tree__node--isExpanded"), isExpanded), _defineProperty(_cx2, "".concat(prefix, "-tree__node--isParent"), isParent), _defineProperty(_cx2, "".concat(prefix, "-tree__node--isRootNode"), isRootNode), _cx2)),
          children: [isParent && !isRootNode && _jsx(Styled.ExpandToggle, {
            onClick: function onClick() {
              return handleOnExpand(node, isExpanded);
            },
            children: _jsx(Icon, {
              icon: isExpanded ? 'chevron-down' : 'chevron-right',
              size: 14
            })
          }), isParent && onlyLeafCheckboxes ? _jsx(Styled.Label, {
            children: node[labelKey]
          }) : _jsx(Checkbox, {
            isChecked: isChecked,
            isDisabled: isDisabled || isUncheckable,
            isInline: true,
            isIndeterminate: isIndeterminate,
            onChange: function onChange() {
              return handleOnChange(node, isChecked, isIndeterminate);
            },
            size: "small",
            children: _jsx(Styled.Label, {
              children: node[labelKey]
            })
          }), node[metadataKey] && _jsx(Styled.Metadata, {
            children: node[metadataKey]
          })]
        }), isParent && _jsx(Styled.NodeChildren, {
          animateOpacity: true,
          duration: 0.25,
          isOpen: isRootNode ? true : isExpanded,
          children: createTree(node[childKey], 20)
        })]
      }, node[valueKey]);
    });
  }

  function createEmptyState() {
    var hasContent = (emptyState === null || emptyState === void 0 ? void 0 : emptyState.title) || (emptyState === null || emptyState === void 0 ? void 0 : emptyState.description);

    if (hasContent) {
      return _jsxs(Styled.EmptyState, {
        children: [(emptyState === null || emptyState === void 0 ? void 0 : emptyState.title) && _jsx(Styled.EmptyStateTitle, {
          children: emptyState.title
        }), (emptyState === null || emptyState === void 0 ? void 0 : emptyState.description) && _jsx(Styled.EmptyStateDescription, {
          children: emptyState.description
        })]
      });
    } else {
      return null;
    }
  }

  function createLoadingState() {
    return _jsx(Styled.EmptyState, {
      children: _jsx(Loading, {
        children: loadingText
      })
    });
  }

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(Styled.ScrollPane, {
      height: height,
      width: width,
      options: {
        resize: resize
      },
      style: {
        paddingLeft: data.length === 1 ? 0 : 'var(--dentsu-spacing-8)'
      },
      children: _jsx(Styled.Tree, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: isLoading ? createLoadingState() : hasData ? createTree(data) : createEmptyState()
      }))
    })
  });
});
Tree.displayName = 'Tree';
export default Tree;